import { gql } from '@apollo/client'

export const LIKE_MUTATION = gql`
  mutation LikeMutation($input: LikeFlagInput){
    likeContent(input: $input)
  }
`;



